import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import { Pie } from "react-chartjs-2";

class OrderPieChart extends Component {
  render() {
    const {
      newConfirmedOrders,
      currentlyDispatchedOrders,
      totalCompletedOrders,
      totalCancelledOrders,
    } = this.props.ordersData;
    const data = {
      labels: ["Confirmed", "Dispatched", "Completed", "Cancelled"],
      datasets: [
        {
          data: [
            newConfirmedOrders,
            currentlyDispatchedOrders,
            totalCompletedOrders,
            totalCancelledOrders,
          ],
          backgroundColor: ["#ced4da", "#4090cb", "#7dfd7d", "#e74c5e"],
        },
      ],
    };

    const option = {
      legend: { display: true, position: "right" },
      datalabels: {
        display: true,
        color: "white",
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var meta = dataset._meta[Object.keys(dataset._meta)[0]];
            var total = meta.total;
            var currentValue = dataset.data[tooltipItem.index];
            var percentage = parseFloat(
              ((currentValue / total) * 100).toFixed(1)
            );
            return currentValue + " (" + percentage + "%)";
          },
          title: function (tooltipItem, data) {
            return data.labels[tooltipItem[0].index];
          },
        },
      },
    };
    return (
      <React.Fragment>
        <Card className="mini-stat bg-pattern">
          <CardBody>
            <h6 className="text-uppercase mb-3 mt-0">Orders</h6>
            <Pie data={data} options={option} />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default OrderPieChart;
